import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ContainerTwoComponents = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  width: 100%;
`;
